import { sellerConstants } from '../../_constants/seller.constants';
import { editSellerService } from '../../_services/';
import { sellerActions } from '../seller.actions';

export const editSellerActions = {
    addData
};

function addData(data, id) {

    return dispatch => {
        dispatch(request());
        editSellerService.updateSeller(data, id)
            .then(
                response => {
                    dispatch(sellerActions.getSellers());
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_UPDATE_SELLER } }
    function success(data) { return { type: sellerConstants.UPDATE_SELLER_SUCCESS, data } }
    function failure(error) { return { type: sellerConstants.UPDATE_SELLER_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/editSeller.actions.js